/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
import React from "react";

export default function LicenseSupportSSO() {
  return (
    <div className="flex flex-col mt-14 mb-6 mx-8 sm:mx-16 xl:mx-28">
      <h1 className="text-3xl text-theme-blue font-bold mb-2 text-center">
        License Support - Gói bảo trì &amp; hỗ trợ kỹ thuật
      </h1>

      {/* Các mục không đánh số */}
      <ul className="space-y-10 mt-3">
        <li>
          <h2 className="text-2xl text-theme-blue font-semibold mb-3">
            1. Mục đích License Support
          </h2>

          <p className="font-light text-lg text-gray-400 text-justify mb-4">
            Tài liệu này quy định phạm vi hỗ trợ kỹ thuật, bảo trì, vận hành và
            đảm bảo chất lượng dịch vụ cho Hệ thống xác thực tập trung người
            dùng (SSO) đã được triển khai và đưa vào sử dụng ổn định trong thời
            gian 01 năm.
          </p>

          <p className="font-light text-lg text-gray-400 text-justify mb-4">
            License Support là căn cứ để:
          </p>
          <ul className="list-disc pl-6 font-light text-lg text-gray-400 text-justify space-y-2">
            <li>
              Xác định giá trị License Support (bao gồm support &amp;
              maintenance) hàng năm.
            </li>
            <li>Xác định phạm vi trách nhiệm của đơn vị cung cấp dịch vụ.</li>
            <li>Đảm bảo hệ thống hoạt động liên tục, an toàn và ổn định.</li>
          </ul>
        </li>

        <li>
          <h2 className="text-2xl text-theme-blue font-semibold mb-3">
            2. Phạm vi hệ thống được hỗ trợ
          </h2>

          <p className="font-light text-lg text-gray-400 text-justify mb-3">
            License Support áp dụng cho{" "}
            <span className="text-black font-bold">
              toàn bộ hệ thống SSO hiện hữu
            </span>
            , bao gồm:
          </p>

          <ul className="list-disc pl-6 font-light text-lg text-gray-400 text-justify space-y-2">
            <li>Hệ thống xác thực tập trung người dùng (SSO)</li>
            <li>
              Các kênh xác thực:
              <ul className="list-disc pl-6 mt-2 space-y-2">
                <li style={{ listStyleType: "'- '" }}>Giao diện Web</li>
                <li style={{ listStyleType: "'- '" }}>Giao diện Mobile</li>
                <li style={{ listStyleType: "'- '" }}>
                  Giao diện Webservices (API)
                </li>
              </ul>
            </li>
            <li>
              Các module quản trị, giám sát và tích hợp đã được nghiệm thu
            </li>
          </ul>

          <p className="font-light text-lg text-gray-400 text-justify mt-3 mb-3">
            Quy mô hỗ trợ:
          </p>
          <ul className="list-disc pl-6 font-light text-lg text-gray-400 text-justify space-y-2">
            <li>
              Số lượng người dùng:{" "}
              <span className="text-black font-bold">≤ 1.500 user</span>
            </li>
            <li>
              Có khả năng mở rộng đến{" "}
              <span className="text-black font-bold">3.000 user</span> (không
              thay đổi chi phí nếu không phát sinh nâng cấp hạ tầng)
            </li>
          </ul>
        </li>

        <li>
          <h2 className="text-2xl text-theme-blue font-semibold mb-3">
            3. Phạm vi chức năng được hỗ trợ theo License Support
          </h2>

          <div className="space-y-8">
            <div>
              <h3 className="text-xl text-theme-blue font-semibold mb-2">
                3.1. Hỗ trợ chức năng xác thực
              </h3>
              <ul className="list-disc pl-6 font-light text-lg text-gray-400 text-justify space-y-2">
                <li>Xác thực tập trung người dùng qua Web, Mobile, API</li>
                <li>Đổi mật khẩu, reset mật khẩu</li>
                <li>Đăng nhập hai bước (2FA)</li>
                <li>Xác thực OTP (SMS, Email, Authenticator)</li>
                <li>
                  Xác thực đa yếu tố (MFA), bao gồm:
                  <ul className="list-disc pl-6 mt-2 space-y-2">
                    <li style={{ listStyleType: "'- '" }}>OTP</li>
                    <li style={{ listStyleType: "'- '" }}>
                      Sinh trắc học (vân tay, khuôn mặt, võng mạc - theo thiết
                      bị)
                    </li>
                    <li style={{ listStyleType: "'- '" }}>
                      Nhận dạng giọng nói (AI - nếu đã triển khai)
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl text-theme-blue font-semibold mb-2">
                3.2. Hỗ trợ quản trị hệ thống
              </h3>
              <ul className="list-disc pl-6 font-light text-lg text-gray-400 text-justify space-y-2">
                <li>
                  Quản lý người dùng:
                  <ul className="list-disc pl-6 mt-2 space-y-2">
                    <li style={{ listStyleType: "'- '" }}>Khóa/mở tài khoản</li>
                    <li style={{ listStyleType: "'- '" }}>Reset mật khẩu</li>
                    <li style={{ listStyleType: "'- '" }}>
                      Đóng băng tài khoản
                    </li>
                    <li style={{ listStyleType: "'- '" }}>
                      Phân quyền người dùng, vai trò
                    </li>
                    <li style={{ listStyleType: "'- '" }}>
                      Quản lý chính sách MFA
                    </li>
                  </ul>
                </li>

                <li>Quản lý ứng dụng tích hợp với SSO</li>
                <li>Hỗ trợ kiểm tra và xử lý log hệ thống</li>
                <li>Xuất log, thống kê truy cập, kiểm tra an toàn hệ thống</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl text-theme-blue font-semibold mb-2">
                3.3. Hỗ trợ tích hợp &amp; đồng bộ
              </h3>
              <ul className="list-disc pl-6 font-light text-lg text-gray-400 text-justify space-y-2">
                <li>Hỗ trợ vận hành các Webservices tích hợp</li>
                <li>Đồng bộ dữ liệu người dùng, tổ chức</li>
                <li>Hỗ trợ tích hợp Email (SMTP)</li>
                <li>Hỗ trợ tích hợp SMS Notification</li>
                <li>Xử lý sự cố liên quan đến kết nối hệ thống bên ngoài</li>
              </ul>
            </div>
          </div>
        </li>

        <li>
          <h2 className="text-2xl text-theme-blue font-semibold mb-3">
            4. Phạm vi License Support (bao gồm hỗ trợ kỹ thuật và bảo trì phần
            mềm)
          </h2>

          <p className="font-light text-lg text-gray-400 text-justify mb-2">
            Gói License Support bao gồm:
          </p>
          <ul className="list-disc pl-6 font-light text-lg text-gray-400 text-justify space-y-2">
            <li>Hỗ trợ khôi phục hệ thống khi xảy ra sự cố</li>
            <li>Kiểm tra định kỳ tình trạng an toàn hệ thống</li>
            <li>Cập nhật các phiên bản nâng cấp mới từ phía nhà cung cấp.</li>
            <li>
              Xử lý và khắc phục mọi lỗi phát sinh của phần mềm trong quá trình
              vận hành.
            </li>
            <li>
              Hỗ trợ kỹ thuật cho đơn vị quản lý và khách hàng trong việc vận
              hành, giám sát hệ thống ứng dụng.
            </li>
            <li>
              Nâng cấp, cập nhật các công nghệ và thư viện (lib) mới mà phần mềm
              đang sử dụng.
            </li>
            <li>
              Vá các lỗ hổng an toàn thông tin và nâng cấp tính năng bảo mật cho
              phần mềm.
            </li>
            <li>
              Hỗ trợ cài đặt lại Phần mềm (nếu cần) để đảm bảo hệ thống luôn
              hoạt động ổn định.
            </li>
            <li>
              Cập nhật hệ thống báo cáo nhằm tuân thủ theo các quy định mới của
              Nhà nước khi có thay đổi.
            </li>
          </ul>
        </li>

        <li>
          <h2 className="text-2xl text-theme-blue font-semibold mb-3">
            5. Mức độ hỗ trợ &amp; SLA
          </h2>

          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-200">
              <thead>
                <tr className="bg-gray-50">
                  <th className="border border-gray-200 px-4 py-3 text-left text-theme-blue font-semibold">
                    Mức độ sự cố
                  </th>
                  <th className="border border-gray-200 px-4 py-3 text-left text-theme-blue font-semibold">
                    Mô tả
                  </th>
                  <th className="border border-gray-200 px-4 py-3 text-left text-theme-blue font-semibold">
                    Thời gian phản hồi
                  </th>
                </tr>
              </thead>
              <tbody className="font-light text-lg text-gray-400">
                <tr>
                  <td
                    style={{ width: "20%" }}
                    className="border border-gray-200 px-4 py-3"
                  >
                    Critical
                  </td>
                  <td
                    style={{ width: "45%" }}
                    className="border border-gray-200 px-4 py-3"
                  >
                    Hệ thống SSO không hoạt động <br />- Là lỗi khiến toàn bộ hệ
                    thống hoặc các chức năng nghiệp vụ then chốt ngừng hoạt động
                    hoàn toàn hoặc gây sai lệch dữ liệu nghiêm trọng ảnh hưởng
                    nhiều hệ thống
                  </td>
                  <td className="border border-gray-200 px-4 py-3">
                    - Thời gian tiếp nhận: Tối đa 1 giờ <br />
                    - Thời gian xử lí tạm thời: Tối đa 2 giờ <br />- Thời gian
                    xử lí triệt để: Tối đa 2 ngày làm việc
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-200 px-4 py-3">High</td>
                  <td className="border border-gray-200 px-4 py-3">
                    Lỗi ảnh hưởng nhiều người dùng
                    <br />- Lỗi chức năng của hệ thống gây ảnh hướng đến tất cả
                    người dùng, đứng luồng xử lý
                  </td>
                  <td className="border border-gray-200 px-4 py-3">
                    - Thời gian tiếp nhận: Tối đa 1 giờ <br />
                    - Thời gian xử lí tạm thời: Tối đa 4 giờ <br />- Thời gian
                    xử lí triệt để: Tối đa 7 ngày làm việc
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-200 px-4 py-3">Medium</td>
                  <td className="border border-gray-200 px-4 py-3">
                    Lỗi chức năng đơn lẻ
                    <br />- Lỗi xảy ra đối với một số tính năng chính của phần
                    mềm, gây ảnh hưởng đến tiến độ công việc hoặc hiệu năng hệ
                    thống giảm đáng kể, nhưng người dùng vẫn có thể thực hiện
                    công việc bằng các giải pháp thay thế tạm thời.
                  </td>
                  <td className="border border-gray-200 px-4 py-3">
                    - Thời gian tiếp nhận: Tối đa 1 giờ <br />
                    - Thời gian xử lí tạm thời: Tối đa 1 ngày làm việc <br />-
                    Thời gian xử lí triệt để: Tối đa 7 ngày làm việc
                  </td>
                </tr>
                <tr>
                  <td className="border border-gray-200 px-4 py-3">Low</td>
                  <td className="border border-gray-200 px-4 py-3">
                    Hỗ trợ nghiệp vụ, hướng dẫn
                    <br />- Các lỗi nhỏ về giao diện, lỗi định dạng hiển thị,
                    hoặc các yêu cầu giải đáp thắc mắc về nghiệp vụ, hướng dẫn
                    sử dụng, thay đổi cấu hình nhẹ mà không ảnh hưởng đến hoạt
                    động chung của hệ thống.
                  </td>
                  <td className="border border-gray-200 px-4 py-3">
                    - Thời gian tiếp nhận: Tối đa 1 giờ <br />
                    - Thời gian xử lí tạm thời: Tối đa 2 ngày làm việc <br />-
                    Thời gian xử lí triệt để: Tối đa 7 ngày làm việc
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="font-light text-lg text-gray-400 text-justify mt-4">
            Khung giờ hỗ trợ:{" "}
            <span className="text-black font-bold">
              Giờ hành chính (Thứ 2 - Thứ 6)
            </span>
            <br />
            (Hỗ trợ ngoài giờ được tính theo thỏa thuận riêng)
          </p>
        </li>

        <li>
          <h2 className="text-2xl text-theme-blue font-semibold mb-3">
            6. Các nội dung không bao gồm trong License Support
          </h2>

          <p className="font-light text-lg text-gray-400 text-justify mb-2">
            License Support{" "}
            <span className="text-black font-bold">không bao gồm:</span>
          </p>
          <ul className="list-disc pl-6 font-light text-lg text-gray-400 text-justify space-y-2">
            <li>Phát triển chức năng mới</li>
            <li>Thay đổi nghiệp vụ hoặc luồng xử lý</li>
            <li>Nâng cấp kiến trúc, mở rộng hạ tầng</li>
            <li>Tích hợp hệ thống mới chưa có trong phạm vi ban đầu</li>
            <li>Thay đổi công nghệ hoặc nền tảng triển khai</li>
            <li>
              Hỗ trợ do lỗi phát sinh từ hạ tầng bên thứ ba (SMS Gateway, Email
              Server…)
            </li>
          </ul>

          <p className="font-light text-lg text-gray-400 text-justify mt-3">
            Các nội dung trên sẽ được báo giá riêng nếu phát sinh.
          </p>
        </li>

        <li>
          <h2 className="text-2xl text-theme-blue font-semibold mb-3">
            7. Thời gian hiệu lực
          </h2>
          <p className="font-light text-lg text-gray-400 text-justify">
            License Support có hiệu lực sau khi hai bên ký kết và thanh toán
            theo Hợp đồng License Support (bao gồm quyền sử dụng license và dịch
            vụ hỗ trợ, bảo trì phần mềm).
          </p>
        </li>
        <li>
          <h2 className="text-2xl text-theme-blue font-semibold mb-3">
            8. Thời gian bảo trì và đầu mối tiếp nhận
          </h2>
          <p className="font-light text-lg text-gray-400 text-justify mb-2">
            Thời gian: Đảm bảo sẵn sàng tiếp nhận 24/7 (24 giờ mỗi ngày, 7 ngày
            mỗi tuần), kể cả ngày lễ và ngày nghỉ.
          </p>
          <p className="font-light text-lg text-gray-400 text-justify mb-2">
            Đầu mối tiếp nhận, 03 kênh tiếp nhận chính thức:
          </p>
          <ul className="list-disc pl-6 font-light text-lg text-gray-400 text-justify space-y-2">
            <li>Hotline: 0977309847</li>
            <li>Email: info@nst.com.vn</li>
            <li>Văn bản: Tiếp nhận yêu cầu qua giấy tờ</li>
          </ul>
        </li>
      </ul>
    </div>
  );
}
